import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';

// Selectors
const SELECTORS = {
    ALL_INPUTS: '.ninja-forms-field:not(.select2-hidden-accessible)',
    FIELD_CONTAINER: '.nf-field-container',
    NINJA_FORMS_FIELD: '.ninja-forms-field',
    FORM: '#revision-form-v2',
    FORM_CONTAINER: '.form-box',
    LOADER: '#loader',
    RESPONSE_ERRORS: '.response-errors',
    SUBMIT_BUTTON: '[type="submit"]',
};

const fieldMapping = {
    'meteringPoint': 'marketLocation',
};

const allowedFields = {
    businessPartner: ['businessPartnerNumber', 'firstName', 'name', 'dateOfBirth'],
    supplyAddress: ['street', 'housenumber', 'housenumberAddition', 'postalCode', 'city'],
    meterNumber: true,
    meteringPoint: true,
    supplierOldILN: true,
    supplierOldCustomerId: true,
};

class RevisionApiServiceV2 {
    constructor() {
        this._loading = false; // Internal loading state
        this.onLoadingChange = null; // Callback for loading state changes
        this.authorizationHeader = this.generateAuthorizationHeader();
        // Absolute path (from myajax, localized in functions.php via get_stylesheet_directory_uri())
        // rather than a relative "../" path - a relative path breaks once the current URL is
        // nested more than one segment deep, since "../" only pops a single path segment
        // instead of resolving back to the site root.
        this.proxyUrl = (typeof myajax !== 'undefined' && myajax.proxy_url) || '../wp-content/themes/gruuun-theme/api-proxi.php';
        this.debounceDelay = 300;
        this.loading = false;
        this.correctionData = {};
        this.nameCanged = false;
        this.tokenValue = '';
        this.uploadedFiles = [];
        this.uploadedPhotos = [];

        this.getTokenValue();

        this.initializeEventListeners();

        this.renderForm();
    }

    // Getter for loading state
    get loading() {
        return this._loading;
    }

    // Setter for loading state with additional logic
    set loading(value) {
        if (this._loading !== value) {
            this._loading = value;
            // Trigger callback if defined
            if (typeof this.onLoadingChange === "function") {
                this.onLoadingChange(value);
            }
        }
    }

    getTokenValue() {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('token')) {
            this.tokenValue = searchParams.get('token');
        }
    }

    // Initialize form logic
    initializeForm() {
        return new Promise((resolve, reject) => {
            try {
                this.initializeUploader();
                this.initializeMobUploader();
                resolve();
            } catch (error) {
                reject('Failed to setup uploader.');
            }
        });
    }

    initializeUploader() {
        const popup = document.getElementById('popup-file-uploader-desktop');
        const dropZone = document.getElementById('drop-zone');
        const uploadArea = popup.querySelector('.upload-area');
        const fileInput = document.getElementById('file-input');

        if (!popup || !dropZone || !fileInput) return;

        // trigger file input on click
        dropZone.addEventListener('click', () => fileInput.click());

        // handle manual file input
        fileInput.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedFile(e.target.files[0], e.target);
            }
        });

        // centralized drag events
        ['dragenter', 'dragover'].forEach(eventName => {
            popup.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = popup.classList.contains('-open');
                const isUploadVisible = !uploadArea.classList.contains('-hidden');

                if (isOpen && isUploadVisible) {
                    dropZone.classList.add('dragover');
                }
            });
        });

        ['dragleave', 'drop'].forEach(eventName => {
            popup.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();

                dropZone.classList.remove('dragover');
            });
        });

        popup.addEventListener('drop', (e) => {
            e.preventDefault();
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleUploadedFile(files[0], fileInput);
            }
        });
    }

    initializeMobUploader() {
        const fileInputMob = document.getElementById('file-input-mob');
        const photoInputMob = document.getElementById('file-photo-mob');
        const addPhoto = document.getElementById('add-photo');

        if (!fileInputMob) return;

        fileInputMob.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedFileMob(e.target.files[0]);
            }
        });

        photoInputMob.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedPhotoMob(e.target.files[0]);
            }
        });

        addPhoto.addEventListener('click', () => photoInputMob.click());
    }

    handleUploadedFile(file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 20 * 1024 * 1024;

        const responseErrorsUploads = $('#popup-file-uploader-desktop .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-desktop .drop-zone .upload-description');
        const uploadHeading = $('#popup-file-uploader-desktop .upload-area .upload-heading');
        const iconSvg = $('#popup-file-uploader-desktop .drop-zone .icon');

        if (!allowedTypes.includes(file.type)) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.html('Ziehe Deine Dateien hier her oder lade sie hoch');
            uploadHeading.html('Deine Uploads');
            iconSvg.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.457 20.707C18.0665 21.0975 17.4335 21.0975 17.043 20.707C16.6524 20.3164 16.6524 19.6834 17.043 19.2929L23.293 13.0429C23.6835 12.6524 24.3165 12.6524 24.707 13.0429L30.957 19.2929L31.0254 19.3691C31.3457 19.7618 31.3231 20.3408 30.957 20.707C30.5909 21.0731 30.0119 21.0957 29.6191 20.7753L29.543 20.707L25 16.164L25 26.9999C25 27.5522 24.5523 27.9999 24 27.9999C23.4477 27.9999 23 27.5522 23 26.9999L23 16.164L18.457 20.707ZM13 31.8749V29.3749C13 28.8226 13.4477 28.3749 14 28.3749C14.5523 28.3749 15 28.8226 15 29.3749V31.8749L15.0078 32.0234C15.042 32.3667 15.1934 32.6894 15.4395 32.9355C15.7208 33.2168 16.1022 33.3749 16.5 33.3749H31.5C31.8978 33.3749 32.2792 33.2168 32.5605 32.9355C32.8419 32.6542 33 32.2727 33 31.8749V29.3749C33 28.8226 33.4477 28.3749 34 28.3749C34.5523 28.3749 35 28.8226 35 29.3749V31.8749C35 32.8032 34.631 33.6932 33.9746 34.3495C33.3182 35.0059 32.4283 35.3749 31.5 35.3749H16.5C15.5717 35.3749 14.6818 35.0059 14.0254 34.3495C13.4101 33.7342 13.0469 32.9137 13.0039 32.0488L13 31.8749Z" fill="#E7E7E7"/>\n' +
                '</svg>');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.html('Ziehe Deine Dateien hier her oder lade sie hoch');
            uploadHeading.html('Deine Uploads');
            iconSvg.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.457 20.707C18.0665 21.0975 17.4335 21.0975 17.043 20.707C16.6524 20.3164 16.6524 19.6834 17.043 19.2929L23.293 13.0429C23.6835 12.6524 24.3165 12.6524 24.707 13.0429L30.957 19.2929L31.0254 19.3691C31.3457 19.7618 31.3231 20.3408 30.957 20.707C30.5909 21.0731 30.0119 21.0957 29.6191 20.7753L29.543 20.707L25 16.164L25 26.9999C25 27.5522 24.5523 27.9999 24 27.9999C23.4477 27.9999 23 27.5522 23 26.9999L23 16.164L18.457 20.707ZM13 31.8749V29.3749C13 28.8226 13.4477 28.3749 14 28.3749C14.5523 28.3749 15 28.8226 15 29.3749V31.8749L15.0078 32.0234C15.042 32.3667 15.1934 32.6894 15.4395 32.9355C15.7208 33.2168 16.1022 33.3749 16.5 33.3749H31.5C31.8978 33.3749 32.2792 33.2168 32.5605 32.9355C32.8419 32.6542 33 32.2727 33 31.8749V29.3749C33 28.8226 33.4477 28.3749 34 28.3749C34.5523 28.3749 35 28.8226 35 29.3749V31.8749C35 32.8032 34.631 33.6932 33.9746 34.3495C33.3182 35.0059 32.4283 35.3749 31.5 35.3749H16.5C15.5717 35.3749 14.6818 35.0059 14.0254 34.3495C13.4101 33.7342 13.0469 32.9137 13.0039 32.0488L13 31.8749Z" fill="#E7E7E7"/>\n' +
                '</svg>');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.html('Lege Deine Dateien in diesem Feld ab oder wähle sie manuell aus.');
        uploadHeading.html('Datei hochladen');
        iconSvg.html('<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.667 33.333V14.667C13.667 12.6419 15.3089 11 17.334 11H26.667C26.6813 11 26.6956 11.0003 26.7098 11.0009C26.9738 11.012 27.2114 11.1255 27.3838 11.3028L34.041 17.96C34.2283 18.1475 34.334 18.4019 34.334 18.667V33.333C34.334 35.3581 32.692 37 30.667 37H17.334C15.3089 37 13.667 35.3581 13.667 33.333ZM25.667 13H17.334C16.4135 13 15.667 13.7465 15.667 14.667V33.333C15.667 34.2535 16.4135 35 17.334 35H30.667C31.5875 35 32.334 34.2535 32.334 33.333V19.667H28C26.7115 19.6668 25.667 18.6216 25.667 17.333V13ZM30.9199 17.667H28C27.8161 17.6668 27.667 17.517 27.667 17.333V14.4141L30.9199 17.667ZM28.1028 24.3385L28.0003 24.3336H20.0003C19.448 24.3336 19.0003 24.7813 19.0003 25.3336C19.0005 25.8858 19.4481 26.3336 20.0003 26.3336H28.0003L28.1028 26.3278C28.6068 26.2764 29.0001 25.8511 29.0003 25.3336C29.0003 24.816 28.607 24.3898 28.1028 24.3385ZM28.1028 29.6719L28.0003 29.667H20.0003C19.448 29.667 19.0003 30.1147 19.0003 30.667C19.0005 31.2191 19.4481 31.667 20.0003 31.667H28.0003L28.1028 31.6611C28.6068 31.6098 29.0001 31.1845 29.0003 30.667C29.0003 30.1493 28.607 29.7232 28.1028 29.6719Z" fill="#E7E7E7"/></svg>');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'desktop');



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const fileSizeKB = file.size / 1024;
        let duration = 500 + ((fileSizeKB - 1) * (3000 - 500)) / (20480 - 1);

        if (fileSizeKB <= 1) {
            duration = 500;
        } else if (fileSizeKB >= 20480) {
            duration = 3000;
        }

        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                // 3. Додати файл у масив
                this.uploadedFiles.push({
                    name: file.name,
                    size: file.size,
                    data: file
                });

                // 4. Сховати прогрес
                this.hideUploadProgress('desktop');

                // 5. Оновити UI
                this.renderUploadedFilesUI();
            }
        }, interval);
    }

    handleUploadedFileMob(file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 20 * 1024 * 1024;

        const responseErrorsUploads = $('#popup-file-uploader-mobile .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-mobile .upload-description');
        const uploadHeading = $('#popup-file-uploader-mobile .upload-area .upload-heading');

        if (!allowedTypes.includes(file.type)) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.show();
        uploadHeading.html('Datei hochladen').css('text-align', 'center');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'mobile');



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const fileSizeKB = file.size / 1024;
        let duration = 500 + ((fileSizeKB - 1) * (3000 - 500)) / (20480 - 1);

        if (fileSizeKB <= 1) {
            duration = 500;
        } else if (fileSizeKB >= 20480) {
            duration = 3000;
        }

        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                // 3. Додати файл у масив
                this.uploadedFiles.push({
                    name: file.name,
                    size: file.size,
                    data: file
                });

                // 4. Сховати прогрес
                this.hideUploadProgress('mobile');

                // 5. Оновити UI
                this.renderUploadedFilesUI();
            }
        }, interval);
    }

    handleUploadedPhotoMob(file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 20 * 1024 * 1024;

        const responseErrorsUploads = $('#popup-file-uploader-mobile .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-mobile .upload-description');
        const uploadHeading = $('#popup-file-uploader-mobile .upload-area .upload-heading');

        if (!allowedTypes.includes(file.type)) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (!file || !(file instanceof File) || file.size === 0 || !file.type || !file.name) {
            responseErrorsUploads.html('<div class="error">Ein Fehler ist aufgetreten</div><div class="hint">Wir konnten Dein Foto nicht hochladen. Bitte versuche es erneut oder lade ein Dokument hoch.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.show();
        uploadHeading.html('Datei hochladen').css('text-align', 'center');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'mobile', true);



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const duration = 2000; // у мс
        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                this.uploadedPhotos.push({
                    name: file.name,
                    size: file.size,
                    data: file
                });

                // 4. Сховати прогрес
                this.showPhotoArea();
            }
        }, interval);
    }


    validateForm() {
        this.setupValidationMessages();
        this.setupValidationMethods();
        this.setupFormValidation();
        this.checkFields();
    }

    initializeEventListeners() {
        // Global event listeners here

        $(document).on('keyup blur change', SELECTORS.ALL_INPUTS, (e) => this.handleInputValidation(e));

        // Handle input events
        $(document).on('input', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleInputEvent(e));

        // Handle focus events
        $(document).on('focus', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleFocusEvent(e));

        // Handle blur events
        $(document).on('blur', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleBlurEvent(e));

        $(document).on('submit', SELECTORS.FORM, this.handleFormSubmit.bind(this));

        this.onLoadingChange = (isLoading) => {
            if (isLoading) {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', true).addClass('-loading');
            } else {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', false).removeClass('-loading');
            }
        };
    }

    generateAuthorizationHeader() {
        const encodedCredentials = btoa(`${this.username}:${this.password}`);
        return `Basic ${encodedCredentials}`;
    }


    renderUploadedFilesUI() {
        const initBox = $('.initial-upload-box');
        const hiddenBox = $('.hidden-upload-box');
        const container = $('.uploaded-files-list');

        container.empty();

        if(this.uploadedFiles.length > 0) {
            this.uploadedFiles.forEach((file, index) => {
                const html = `
                    <div class="upload-entry" data-index="${index}">
                        <div class="file-name text-3">${file.name}</div>
                        <div class="file-size text-3">${(file.size / 1024).toFixed(0)} KB</div>
                        <button class="delete-upload" data-index="${index}"></button>
                    </div>
                `;
                container.append(html);
            });

            if(!initBox.hasClass('-hidden') && !hiddenBox.hasClass('-visible')) {
                initBox.addClass('-hidden');
                hiddenBox.addClass('-visible');
            }
        } else {
            initBox.removeClass('-hidden');
            hiddenBox.removeClass('-visible');
        }
    }

    showUploadProgress(file, device, photo = false) {
        const correctPopup = device === 'desktop'? $('#popup-file-uploader-desktop') : $('#popup-file-uploader-mobile');
        const uploadArea = correctPopup.find('.upload-area');
        const progressArea = correctPopup.find('.progress-area');
        const fileUploading = correctPopup.find('.file-uploading .file-info');
        const fileUploadingBox = correctPopup.find('.file-uploading');
        const photoArea = correctPopup.find('.photo-area');

        if(photo) {
            fileUploadingBox.addClass('-photo');
        } else {
            fileUploadingBox.removeClass('-photo');
        }

        const html = `
            <div class="file-name text-3">${file.name}</div>
            <div class="file-size text-3">0 KB von ${(file.size / 1024).toFixed(0)} KB</div>
        `;
        fileUploading.html(html);

        if(!progressArea.hasClass('-visible')) {
            uploadArea.addClass('-hidden');
            progressArea.addClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    hideUploadProgress(device) {
        const popupUpload = device === 'desktop'? $('#popup-file-uploader-desktop') : $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const progressLineFilled = popupUpload.find('.progress-line .filled');
        const fileUploading = popupUpload.find('.file-uploading .file-info');
        const photoArea = popupUpload.find('.photo-area');

        popupUpload.removeClass('-open');
        $('body').removeClass('overflow-hidden');

        fileUploading.empty();
        progressLineFilled.css('width', `0%`);
        uploadArea.removeClass('-hidden');
        progressArea.removeClass('-visible');
        photoArea.removeClass('-visible');
    }

    showPhotoArea() {
        const popupUpload = $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const photoArea = popupUpload.find('.photo-area');
        const countDiv = popupUpload.find('.photos-count');

        const container = $('.photos-list');
        const photoItems = container.find('.item-default');
        const photoCount = this.uploadedPhotos.length;

        photoItems.remove();

        if(photoCount > 0) {
            if(photoCount > 1) {
                countDiv.html(`(${photoCount} Fotos)`);
            } else {
                countDiv.html(`(${photoCount} Foto)`);
            }

            this.uploadedPhotos.forEach((file, index) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const base64 = e.target.result;

                    const html = `
                    <div class="item-default" data-index="${index}" style="background-image: url('${base64}')">
                        <button class="delete-photo" data-index="${index}"></button>
                    </div>
                `;
                    if(container.hasClass('mCustomScrollbar')) {
                        container.find('.mCSB_container').append(html);
                    } else {
                        container.append(html);
                    }
                };
                reader.readAsDataURL(file.data);
            });

            if (container.hasClass('mCustomScrollbar')) {
                container.mCustomScrollbar('destroy');
            }

            setTimeout(() => {
                container.mCustomScrollbar({
                    theme: 'light-thick',
                    axis: 'x',
                    contentTouchScroll: 25,
                    advanced: {
                        updateOnContentResize: true
                    },
                    mouseWheel: {
                        enable: true
                    }
                });
            }, 0);

            uploadArea.addClass('-hidden');
            progressArea.removeClass('-visible');
            photoArea.addClass('-visible');
        } else {
            uploadArea.removeClass('-hidden');
            progressArea.removeClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    pushPhotos() {
        const popupUpload = $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const photoArea = popupUpload.find('.photo-area');


        if (Array.isArray(this.uploadedPhotos) && this.uploadedPhotos.length > 0) {
            this.uploadedPhotos.forEach(photo => {
                this.uploadedFiles.push(photo);
            });

            this.hideUploadProgress('mobile');

            this.renderUploadedFilesUI();

            this.uploadedPhotos = [];

            popupUpload.removeClass('-open');
            $('body').removeClass('overflow-hidden');

            uploadArea.removeClass('-hidden');
            progressArea.removeClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    showLoader() {
        $(SELECTORS.LOADER).show();
    }

    hideLoader() {
        $(SELECTORS.LOADER).hide();
    }

    setupValidationMessages() {
        $.extend($.validator.messages, {
            required: "Dieses Feld wird benötigt.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            number: "Bitte geben Sie eine gültige Zahl ein.",
            range: $.validator.format("Bitte geben Sie einen Wert zwischen {0} und {1} ein."),
            max: $.validator.format("Bitte geben Sie einen Wert kleiner oder gleich {0} ein."),
            min: $.validator.format("Bitte geben Sie einen Wert größer oder gleich {0} ein."),
            digits: "Nur Zahlen sind erlaubt.",
            rangelength: $.validator.format("Bitte geben Sie genau {0} Zeichen ein.")
        });
    }

    setupValidationMethods() {
        $.validator.addMethod("customEmail", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        }, "Bitte geben Sie eine gültige E-Mail-Adresse ein.");

        $.validator.addMethod("alphanumeric", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben und Zahlen ein.");

        $.validator.addMethod("lettersDigitsHyphen", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9-]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Zahlen und Bindestriche ein.");

        $.validator.addMethod("numeric_period_hyphen", function (value, element) {
            return this.optional(element) || /^[A-Za-z0-9.-]*$/.test(value);
        }, "Bitte geben Sie nur Zahlen, Punkte und Bindestriche ein.");

        $.validator.addMethod("lettersWithDashesDiacritics", function (value, element) {
            return this.optional(element) || /^[a-zA-ZÀ-ž\- ]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Bindestriche und diakritische Zeichen ein.");

        $.validator.addMethod("dateRange", function (value, element, params) {
            const selectedDate = new Date(value);
            const minDate = params[0];
            const maxDate = params[1];
            return this.optional(element) || (selectedDate >= minDate && selectedDate <= maxDate);
        }, "Ihr Alter muss über 18 oder unter 130 Jahre liegen.");

        $.validator.addMethod("numbersAndPlus", function (value, element) {
            return this.optional(element) || /^[0-9+]+$/.test(value);
        }, "Bitte geben Sie nur Zahlen und '+' ein.");

        $.validator.addMethod("lettersAndDash", function (value, element) {
            return this.optional(element) || /^[a-zA-ZäöüßÄÖÜ\s-]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben und '-' ein.");

        $.validator.addMethod("lettersAndDashAndDot", function (value, element) {
            return this.optional(element) || /^[a-zA-ZäöüßÄÖÜ\s\-.]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, '-', '.' und Leerzeichen ein.");

        $.validator.addMethod("lettersNumbersSlash", function (value, element) {
            return this.optional(element) || /^[a-zA-ZäöüßÄÖÜ0-9\s/]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Zahlen und '/' ein.");

    }

    setupFormValidation(form) {

        $(SELECTORS.FORM).validate({
            rules: {
                marketLocation: {
                    digits: true,
                    rangelength: [11, 11]
                },
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.field-wrap').find('.nf-error-msg'));
            },
            highlight: function (element) {
                $(element).closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
            },
            unhighlight: function (element) {
                $(element).closest('.field-wrap').removeClass('nf-error');
            },
            success: function (label, element) {
                if($(element).val() !== '') {
                    $(element).closest('.field-wrap').addClass('nf-pass');
                }
            },
        });
    }


    handleInputValidation(event) {
        let $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);
        const $wrap = $input.closest('.field-wrap');

        if ($input.length > 0) {
            if ($input.attr('type') === 'hidden') {
                $input = $input.next();
            }
        }

        // Validate the input
        $(SELECTORS.FORM).validate().element($input[0]);

        // Add or remove "fake-nf-pass" based on the input value
        if (($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr) {
            if ($input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            } else {
                $container.removeClass('fake-nf-pass');
                $wrap.removeClass('nf-pass');
            }
        }
    }

    handleInputEvent(event) {
        const $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);
        let value = $input.val();

        if ($input.is('select[multiple]')) {
            value = Array.isArray(value) && value.length > 0 ? value.join('').trim() : '';
        } else if ($input.is('select')) {
            value = value ? value.trim() : '';
        } else if (typeof value === 'string') {
            value = value.trim();
        } else {
            value = '';
        }

        $container.removeClass('potentially-required-label');
        if (value !== '') {
            $container.addClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        } else {
            $container.removeClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        }
    }

    handleFocusEvent(event) {
        const $input = $(event.currentTarget);
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);

        $container.addClass('label-focus');
        $container.removeClass('potentially-required-label');
    }

    handleBlurEvent(event) {
        const $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);

        $container.removeClass('potentially-required-label');
        $container.removeClass('label-focus');
        if ($input.val().trim() === '') {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        } else {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        }
    }

    // Check Ninja Forms fields
    checkFields() {
        $(SELECTORS.ALL_INPUTS).each(function () {
            let $input = $(this);
            let $attr = $input.attr('required');
            let $container = $input.closest(SELECTORS.FIELD_CONTAINER);

            $container.addClass('active-label');
            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
            if (typeof $attr !== 'undefined' && $attr !== false && ((!$.isArray($input.val()) && $input.val().trim() === '') || ($.isArray($input.val()) && $input.val().length > 0))) {
                $container.addClass('potentially-required-label');
            }

            if (($input.is('[type="text"]') || $input.is('[type="email"]') || $input.is('[type="tel"]') || $input.is('[type="number"]') || $input.is('[type="date"]')) && $input.val().trim() !== '') {
                $(SELECTORS.FORM).validate().element($input[0]);
            }

            if (($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr && $input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            }
        });
    }

    getCorrectionData() {
        if (this.loading === true) {
            return;
        }
        this.loading = true;
        this.showLoader();

        let sendData = {};

        if (this.tokenValue) {
            sendData.value = this.tokenValue;

            return new Promise((resolve, reject) => {
                // resolve({correctionData: true});
                $.ajax({
                    url: `${this.proxyUrl}?type=getCorrectionDataByCancellation`,
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(sendData),
                    headers: {
                        'Authorization': this.authorizationHeader
                    },
                    success: function (response) {
                        resolve(response);
                    },
                    error: function (xhr, status, error) {
                        reject(error);
                    }
                });
            });
        } else {
            return Promise.reject('Token is missing in URL parameters');
        }
    }

    setNestedValue(obj, path, value) {
        const keys = path.split('.');
        keys.reduce((acc, key, index) => {
            if (index === keys.length - 1) {
                acc[key] = value;
            } else {
                acc[key] = acc[key] || {};
            }
            return acc[key];
        }, obj);
    }

    getEmptyForm() {
        const bodyClass = $('body').attr('class');
        const pageIdMatch = bodyClass.match(/page-id-(\d+)/);
        const pageId = pageIdMatch ? pageIdMatch[1] : null;

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: {
                    action: 'get_correction_form_v2',
                    page_id: pageId,
                    nonce: myajax.nonces.get_correction_form_v2,
                },
                success: function (response) {
                    if (response.data && response.data.form) {
                        $(SELECTORS.FORM_CONTAINER).html(response.data.form);
                        resolve();
                    } else {
                        reject('Empty response or form data is missing.');
                    }
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    getNestedValue(obj, path) {
        if (!obj || !path) return null;
        return path.split('.').reduce((acc, key) => {
            return acc && acc[key] !== undefined ? acc[key] : null;
        }, obj);
    }


    renderForm() {
        let sendData = {};

        if (!this.tokenValue) {
            $(SELECTORS.FORM_CONTAINER).html(`<div class="page-title error-token"><h1>Herzlich Willkommen!</h1> <div class="text-2"><p>Diesen Seite kann nur mit einem gültigen Token geöffnet werden. Sollten wir Deine Mithilfe bei der Anmeldung Deines Stromvertrages benötigen, schicken wir Dir eine E-Mail mit einem persönlichen Token zu. Falls Du keine solche Mail erhalten hast musst Du nichts unternehmen.</p></div></div>`);
            return;
        }

        this.getCorrectionData()
            .then(data => {
                if (!data.correctionData) {
                    return Promise.reject('Correction data is missing.');
                }

                this.correctionData = data.correctionData;
                console.log('Processing correction data:', data.correctionData);
                return this.getEmptyForm();
            })
            .then(() => {
                this.hideLoader();
                this.loading = false;

                console.log('Form initialized.');

                return this.initializeForm();
            })
            .then(() => {
                console.log('Correction data applied to the form successfully.');

                this.validateForm();
            })
            .catch(error => {
                this.hideLoader();
                this.loading = false;

                console.error('Failed to render form:', error);
                $(SELECTORS.FORM_CONTAINER).html(
                    `<div class="page-title error-token">
                                <h1>Vielen Dank für Deine Mithilfe. Wir konnten Deine aktuellen Daten nicht laden. Dies kann zwei Ursachen haben:</h1>
                                <div class="text-2">
                                    <ol>
                                        <li>Dein persönlicher Link läuft aus Datenschutzgründen nach 7 Tagen ab. Bitte schau in Deinen Mails, ob Du eine neuere Mail von uns erhalten hast.</li>
                                        <li>Du hast Deine korrigierten Daten bereits erfolgreich übermittelt. In diesem Fall haben wir Deinen Wechselprozess neu angestoßen und Du wirst in Kürze von uns hören. Weitere Anpassungen Deiner Daten kannst Du jederzeit im Kundenportal vornehmen.</li>
                                    </ol>
                                </div>
                            </div>`
                );
            });
    }

    createSendDataForCancellation() {
        let sendData = {};

        // Filter correction data to include only allowed fields
        Object.entries(allowedFields).forEach(([key, value]) => {
            if (typeof value === 'boolean' && value === true) {
                // Directly include the key if it’s a boolean and true
                const nestedValue = this.getNestedValue(this.correctionData, key);
                if (nestedValue !== undefined) {
                    this.setNestedValue(sendData, key, nestedValue);
                }
            } else if (Array.isArray(value)) {
                // For nested objects, include only allowed subfields
                const nestedObject = this.getNestedValue(this.correctionData, key);
                if (nestedObject) {
                    sendData[key] = {};
                    value.forEach((subKey) => {
                        if (nestedObject[subKey] !== undefined) {
                            sendData[key][subKey] = nestedObject[subKey];
                        }
                    });
                }
            }
        });

        if (!this.tokenValue) {
            console.error('Token value is missing.');
            this.loading = false;
            return;
        }

        // Add token value to the request payload
        sendData.tokenValue = this.tokenValue;

        console.log(sendData);

        return sendData;
    }

    sendFilesToEmail() {
        const formData = new FormData();
        const contractNumber = this.correctionData.contract.contractNr;

        this.uploadedFiles.forEach((file, index) => {
            formData.append(`file_${index}`, file.data, file.name);
        });

        formData.append('action', 'send_email_with_files');
        formData.append('contract_number', contractNumber);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: (res) => {
                    if (res.success) {
                        resolve(res);
                    } else {
                        $('.response-errors').html('<div class="error">Fehler beim Senden der Dateien.</div>');
                        reject('Fehler beim Senden der Dateien.');
                    }
                },
                error: () => {
                    $('.response-errors').html('<div class="error">Fehler beim Upload.</div>');
                    reject('Fehler beim Upload.');
                }
            });
        });
    }

    convertTimestampToISO(timestamp) {
        if (!timestamp) return null;
        const date = new Date(parseInt(timestamp, 10));
        return date.toISOString();
    }

    updateCorrectionData() {
        const errorsContainer = $(SELECTORS.RESPONSE_ERRORS);

        return new Promise((resolve, reject) => {

            if(this.correctionData.contract.state && (this.correctionData.contract.state === 'CANCELED' || this.correctionData.contract.state === 'LOCKED')) {
                errorsContainer.append('<div class="error">Vielen Dank für Deine Mithilfe! Wir konnten Deine Anpassungen nicht speichern. Dein Vertrag ist nicht mehr aktiv. Für mehr Informationen prüfe bitte Deine E-Mails oder wende Dich an unseren Kundenservice.</div>');
                return reject('CANCELED || LOCKED');
            } else if(!this.correctionData.contract.state || (this.correctionData.contract.state && this.correctionData.contract.state !== 'CANCELED' && this.correctionData.contract.state !== 'LOCKED' && this.correctionData.contract.state !== 'GPKE_ABORTED')) {
                errorsContainer.append('<div class="error">Vielen Dank für Deine Mithilfe! Wir konnten Deine Anpassungen nicht speichern. Dein Vertragsstatus hat sich geändert und wir konnten den Anmeldeprozess mit Deinem Netzanbieter neu starten. Wir melden uns bei Dir, sobald wir Neuigkeiten haben.</div>');
                return reject('!CANCELED && !LOCKED && !GPKE_ABORTED');
            }

            try {
                // Utility function for date formatting
                const formatDateToISO = (dateString) => {
                    const date = new Date(dateString);
                    return date.toISOString();
                };

                if (this.correctionData.businessPartner && this.correctionData.businessPartner.dateOfBirth) {
                    this.correctionData.businessPartner.dateOfBirth = this.convertTimestampToISO(
                        this.correctionData.businessPartner.dateOfBirth
                    );
                }

                // Iterate over `fieldMapping` to update `sendData` based on form inputs
                Object.entries(fieldMapping).forEach(([key, name]) => {
                    const field = $(`[name="${name}"]`);
                    if (field.length && field.val()) {
                        let value = field.val();

                        const finalValue = value !== undefined && value !== null && value.trim() !== '' ? value : null;
                        this.setNestedValue(this.correctionData, key, finalValue); // Update the nested value in `this.correctionData`
                    }
                });

                // If success -> resolve()
                resolve('updateCorrectionData completed successfully');
            } catch (error) {
                // If error -> reject(error)
                reject(error);
            }
        });

    }

    requestsToApiCancellation(sendData) {
        const Api = this;
        const errorsContainer = $(SELECTORS.RESPONSE_ERRORS);

        return new Promise((resolve, reject) => {
            console.log('Prepared data for submission:', sendData);

            // Send the updated data via AJAX
            $.ajax({
                url: `${this.proxyUrl}?type=saveCorrectionDataByCancellation`,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(sendData), // Serialize the payload as JSON
                headers: {
                    'Authorization': this.authorizationHeader, // Add authorization header
                },
                success: function (response) {
                    // Check if there are validation results
                    if (response.validationResults && response.validationResults.length > 0) {
                        // Handle validation errors
                        errorsContainer.empty(); // Clear previous errors, if any

                        // Iterate through validationResults and display each error
                        response.validationResults.forEach(function (errorItem) {
                            const errorMessage = errorItem.errorMessage || 'Unknown error';
                            errorsContainer.append('<div class="error">'+errorMessage+'</div>');
                        });

                        Api.loading = false;

                        reject('Validation errors occurred');
                    } else {
                        console.log('Data saved successfully requestsToApiCancellation:', response); // Log success message

                        resolve(response);
                    }
                },
                error: function (xhr, status, error) {
                    console.error('Failed to save data:', error); // Log error details
                    errorsContainer.append('<div class="error">Failed to save data: '+error+'</div>');

                    Api.loading = false;
                    reject(error);
                }
            });
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();

        if (this.loading === true) {
            return; // Prevent duplicate submissions
        }
        this.loading = true;

        let sendDataForDisable = {
            token: ''
        };

        const hasFiles = this.uploadedFiles.length > 0;
        const marketLocationValue = $('[name="marketLocation"]').val().trim();

        if (!hasFiles && !marketLocationValue) {
            $('.response-errors').html('<div class="error">Bitte gib die Marktlokations-ID ein oder lade ein Dokument hoch.</div>');
            this.loading = false;
            return;
        }

        let sendToApi = false;
        let sendToMail = false;

// Case 1: nur Markt-ID
        if (marketLocationValue && !hasFiles) {
            sendToApi = true;
        }

// Case 2: nur Upload
        else if (!marketLocationValue && hasFiles) {
            sendToMail = true;
        }

// Case 3: beide
        else if (marketLocationValue && hasFiles) {
            sendToApi = true;
            sendToMail = true;
        }

        this.updateCorrectionData()
            .then(() => {
                console.log('updateCorrectionData completed.');

                return this.createSendDataForCancellation();
            })
            .then((sendData) => {

                if (!sendData) {
                    throw new Error('No sendData available');
                }

                if(sendToApi) {
                    console.log('requestsToApiCancellation');
                    return this.requestsToApiCancellation(sendData);
                } else {
                    return Promise.resolve();
                }

            })
            .then(() => {

                if(sendToMail) {
                    console.log('sendFilesToEmail');
                    return this.sendFilesToEmail();
                } else {
                    return Promise.resolve();
                }
            })
            .then(() => {

                if(!sendToApi) {
                    console.log('disableToken');
                    sendDataForDisable.token = this.tokenValue;

                    return new Promise((resolve, reject) => {
                        $.ajax({
                            url: `${this.proxyUrl}?type=disableToken`,
                            method: 'POST',
                            contentType: 'application/json',
                            data: JSON.stringify(sendDataForDisable),
                            headers: {
                                'Authorization': this.authorizationHeader,
                            },
                            success: (response) => {
                                resolve(response);
                            },
                            error: (xhr, status, error) => {
                                console.error('Failed to disable token:', error);
                                reject(error);
                            }
                        });
                    });
                } else {
                    return Promise.resolve();
                }
            })
            .then(() => {
                console.log(`All requests finished successfully. Redirect to /clp-success?email=${this.correctionData.businessPartner.email}&firstname=${this.correctionData.businessPartner.firstName}`);

                window.location.href = `/clp-success?email=${this.correctionData.businessPartner.email}&firstname=${this.correctionData.businessPartner.firstName}`;
            })
            .catch(error => {
                console.error('Error in chain:', error);
                this.loading = false;
            });
    }



}

// Initialize Revision API service
const revisionApiServiceV2 = new RevisionApiServiceV2();

$(document).on('click', '.delete-upload', function () {
    const index = $(this).data('index');
    revisionApiServiceV2.uploadedFiles.splice(index, 1);
    revisionApiServiceV2.renderUploadedFilesUI();
});

$(document).on('click', '.delete-photo', function () {
    const index = $(this).data('index');
    revisionApiServiceV2.uploadedPhotos.splice(index, 1);
    revisionApiServiceV2.showPhotoArea();
});

$(document).on('click', '#push-photos', function () {
    revisionApiServiceV2.pushPhotos();
});

$(document).on('click', '.upload-tooltip-opener:not(:disabled)', function (e) {
    e.preventDefault();
    const isMobileCameraCapable = () => {
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isSmallScreen = window.innerWidth <= 768;
        const hasCamera = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

        // return isTouch && isSmallScreen && hasCamera;
        return isTouch && hasCamera;
        // return true;
    };

    if (isMobileCameraCapable()) {
        $('#popup-file-uploader-mobile').addClass('-open');
    } else {
        $('#popup-file-uploader-desktop').addClass('-open');
    }
    $("body").addClass("overflow-hidden");
});

//Combine event handlers for close buttons and modal overlays.
$(document).on("click", ".upload-popup .close-button, .upload-popup .modal-overlay", function (e) {
    const modalPopup = $(this).closest(".upload-popup");

    modalPopup.removeClass("-open");
    $("body").removeClass("overflow-hidden");
});

$(document).on('change', 'input[name="uploaderApprove"]', (e) => {
    if (!$(e.currentTarget).is(':checked')) {
        $('#upload-tooltip-opener').attr('disabled', 'disabled');
    } else {
        $('#upload-tooltip-opener').removeAttr('disabled');
    }
})
